import {css, styled} from "@mui/material/styles";
import StarIcon from "@mui/icons-material/Star";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import {Paper} from "@mui/material";

export const StarIconBackground = styled(StarIcon)<{isDetailed?: boolean}>`
  position: absolute;
  ${({isDetailed}) => (isDetailed && css`
    color: red;
  `)}
  top: 2px;
  left: -1px;
  width: 18px;
  height: 18px;
  
`;
export const StarIconFront = styled(StarBorderIcon)<{isDetailed?: boolean}>`
  ${({isDetailed}) => (isDetailed && css`
    color: red;
  `)}
  position: absolute;
  top: 2px;
  left: 8px;
  width: 18px;
  height: 18px;
`;

export const ListItemContainer = styled(Paper)<{
  isNextSameRow?: boolean;
  isPrevSameRow?: boolean;
  isSelected?: boolean;
}>`
  border: 2px solid #cdcdcd;
  padding: 1.5px;
  border-bottom-width: ${({isNextSameRow}) => isNextSameRow ? 0 : '2px'};
  border-top-width: ${({isPrevSameRow}) => isPrevSameRow ? 0 : '2px'};
  margin-top: ${({isPrevSameRow}) => isPrevSameRow ? 0 : '1px'} !important;
  margin-bottom: ${({isNextSameRow}) => isNextSameRow ? 0 : '1px'} !important;
  
  &:hover{
    border: 1px solid rgba(245, 123, 32, 0.6);
    padding: 2.5px;

    ${({isNextSameRow}) => isNextSameRow && css`
      padding-bottom: 0 !important;
    `}
    ${({isPrevSameRow}) => isPrevSameRow && css`
      padding-top: 0 !important;
    `}
    
  }
  
  ${({isSelected}) => isSelected && css`
    padding: 0px 0px 0px 0.5px !important;
    border: 3.5px solid rgba(245, 123, 32, 0.6) !important;
    width: calc(100% - 7px) !important;
    ms-width: 100% !important;
    height: 34px !important;
    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
      height: auto;
    }
  `}
  
`;
